import { Controller } from "@hotwired/stimulus"

// Updates a deep-link anchor based on the selected UET tag dropdown value, so the user can
// jump directly from Switch's destination form to the corresponding tag's edit page in
// Microsoft Advertising — which is where the CAPI token is generated.
//
// The base URL (with aid/cid prefilled from the platform connection) is rendered server-side
// and passed via the base-url value. This controller only appends the `uetTagId` query
// parameter based on the dropdown's current selection.
//
// Usage:
//   <div data-controller="uet-tag-link"
//        data-uet-tag-link-base-url-value="https://ui.ads.microsoft.com/.../uettags?aid=...&cid=...&ccuisrc=4">
//     <select data-uet-tag-link-target="select"
//             data-action="change->uet-tag-link#update">...</select>
//     <a data-uet-tag-link-target="link" target="_blank" rel="noopener" class="hidden">Open in MSA</a>
//   </div>
export default class extends Controller {
  static targets = ["select", "link"]
  static values = { baseUrl: String }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasSelectTarget || !this.hasLinkTarget || !this.baseUrlValue) return

    const tagId = this.selectTarget.value
    if (tagId) {
      const separator = this.baseUrlValue.includes("?") ? "&" : "?"
      // MSA's edit page path is `/uettags/edit`; without a tag the base URL points at the list.
      const editUrl = this.baseUrlValue.replace(/\/uettags(\?|$)/, "/uettags/edit$1")
      this.linkTarget.href = `${editUrl}${separator}uetTagId=${encodeURIComponent(tagId)}`
      this.linkTarget.classList.remove("hidden")
    } else {
      this.linkTarget.href = this.baseUrlValue
      this.linkTarget.classList.remove("hidden")
    }
  }
}
